import { Box, Container, Heading, Text, VStack, HStack, Badge, Icon, Flex } from "@chakra-ui/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../components/student/Layout/layout";
import QRCode from "qrcode.react";
import EnrolledCourses from "../../containers/student/home/enrolledCourses";
import PendingCourses from "../../containers/student/home/pendingCourses";
import { FaQrcode, FaUserGraduate, FaBookOpen } from "react-icons/fa";
import {
  getEnrolledCoursesRequest,
  getPendingCoursesRequest,
} from "../../modules/students-modules/courses/Actions";

const StudentHome = () => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user.userData);
  const liveVideo = useSelector((state) => state.chapterVideos.liveVideo);
  
  console.log(liveVideo);
  
  useEffect(() => {
    dispatch(getEnrolledCoursesRequest());
    dispatch(getPendingCoursesRequest());
  }, []);

  return (
    <Layout color="main_1" bg="white">
      {/* Combined Welcome and QR Code Section */}
      <Box
        bg="main_1"
        color="white"
        w="100%"
        py="60px"
        px="20px"
        position="relative"
        overflow="hidden"
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 100 100\"><defs><pattern id=\"grain\" width=\"100\" height=\"100\" patternUnits=\"userSpaceOnUse\"><circle cx=\"25\" cy=\"25\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"75\" cy=\"75\" r=\"1\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"50\" cy=\"10\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"10\" cy=\"60\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/><circle cx=\"90\" cy=\"40\" r=\"0.5\" fill=\"white\" opacity=\"0.1\"/></pattern></defs><rect width=\"100\" height=\"100\" fill=\"url(%23grain)\"/></svg>')",
          opacity: 0.3,
        }}
      >
        <Container maxW="container.xl" position="relative" zIndex={1}>
          <HStack 
            spacing={12} 
            align="center" 
            justify="space-between"
            direction={{ base: "column", lg: "row" }}
          >
            {/* QR Code Section - Left Side */}
            <VStack spacing={6} flexShrink={0}>
              <VStack spacing={1} pt={4}>
                <Icon as={FaQrcode} boxSize={6} color="yellow.300" />
                <Heading size="md" color="white">
                  Attendance QR Code
                </Heading>
              </VStack>
              
              <Box
                bg="white"
                p={6}
                borderRadius="2xl"
                boxShadow="0 10px 25px rgba(0,0,0,0.2)"
                border="2px solid"
                borderColor="rgba(255,255,255,0.2)"
                _hover={{
                  transform: "translateY(-2px)",
                  boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                }}
                transition="all 0.3s ease"
              >
                <VStack spacing={3}>
                  <Box
                    bg="white"
                    p={4}
                    borderRadius="xl"
                    border="2px solid"
                    borderColor="gray.200"
                    _hover={{
                      borderColor: "main_1",
                    }}
                    transition="border-color 0.3s ease"
                  >
                    <QRCode
                      size={180}
                      value={`https://enoughphysics.com/scan-code/${userData?.id}/attendence`}
                      level="H"
                      includeMargin={true}
                    />
                  </Box>
                  <Text fontSize="sm" color="gray.500" textAlign="center">
                    Student ID: {userData?.id}
                  </Text>
                </VStack>
              </Box>
            </VStack>

            {/* Welcome Text Section - Right Side */}
            <VStack 
              spacing={6} 
              align={{ base: "center", lg: "flex-start" }}
              textAlign={{ base: "center", lg: "left" }}
              flex={1}
            >
              <VStack spacing={4} align={{ base: "center", lg: "flex-start" }}>
                <Icon as={FaUserGraduate} boxSize={10} color="yellow.300" />
                <Heading 
                  size="2xl" 
                  fontWeight="bold"
                  textShadow="0 2px 4px rgba(0,0,0,0.3)"
                >
                  Welcome back, {userData?.name}!
                </Heading>
                <Text 
                  fontSize="lg" 
                  opacity={0.9}
                  maxW="500px"
                  lineHeight="1.6"
                >
                  Ready to continue your learning journey on Agwad, the most innovative portal for students
                </Text>
              </VStack>
            </VStack>
          </HStack>
        </Container>
      </Box>

      {/* Enhanced Content Section */}
      <Box bg="gray.50" py="60px">
        <Container maxW="container.2xl" px="20px">
          <VStack spacing={12}>
            {/* Enrolled Courses Section */}
            <Box w="100%">
              <VStack spacing={6} align="stretch">
                <Box>
                  <Heading size="lg" color="gray.800" mb={2}>
                    Your Enrolled Courses
                  </Heading>
                  <Text color="gray.600">
                    Continue learning from where you left off
                  </Text>
                </Box>
                <Box
                  bg="white"
                  borderRadius="xl"
                  p={6}
                  boxShadow="0 4px 6px rgba(0,0,0,0.05)"
                >
                  <EnrolledCourses />
                </Box>
              </VStack>
            </Box>

            {/* Pending Courses Section */}
            <Box w="100%">
              <VStack spacing={6} align="stretch">
                <Box>
                  <Heading size="lg" color="gray.800" mb={2}>
                    Available Courses
                  </Heading>
                  <Text color="gray.600">
                    Discover new courses to expand your knowledge
                  </Text>
                </Box>
                <Box
                  bg="white"
                  borderRadius="xl"
                  p={6}
                  boxShadow="0 4px 6px rgba(0,0,0,0.05)"
                >
                  <PendingCourses />
                </Box>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>
    </Layout>
  );
};

export default StudentHome;
